export var GVCInternalRouterEvent;
(function (GVCInternalRouterEvent) {
    GVCInternalRouterEvent["RouterConnected"] = "connected";
    GVCInternalRouterEvent["RouterDisconnected"] = "disconnected";
    GVCInternalRouterEvent["RouterAddrs"] = "addrs";
    GVCInternalRouterEvent["RouterCordonSFU"] = "cordon-sfu";
})(GVCInternalRouterEvent || (GVCInternalRouterEvent = {}));
//# sourceMappingURL=RouterEvent.js.map